import { Cascader, Form, Modal } from 'antd'
import moment from 'moment'
import * as React from 'react'

import { IRaccoltaDatiService } from '../../services/RaccoltaDatiService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { MovimentoEditModel } from '../../models/RaccoltaDatiModels'

import { formatEuro } from '../shared/CurrencyFormat'
import { TTFormItem } from '../shared/TTFormItem'
import { TTModalProps } from '../shared/TTModalProps'
import { IApiService } from '../../services/shared/ApiService'
import { CascaderOptionType } from 'antd/lib/cascader'

interface ModalMovimentoProps extends TTModalProps {
    id: string
}

class ModalMovimentoState extends MovimentoEditModel { }

const filter = (inputValue: string, path: CascaderOptionType[]): boolean => {
    return path.some(
        option =>
            (option.label as string).toLowerCase().indexOf(inputValue.toLowerCase()) > -1

    )
}

export class ModalMovimento extends React.Component<ModalMovimentoProps, ModalMovimentoState> {

    service: IRaccoltaDatiService

    constructor(props) {
        super(props)
        this.state = new ModalMovimentoState()

        this.service = container.get(SERVICE_IDENTIFIER.RACCOLTA_DATI_SERVICE);

    }

    componentDidMount() {
        this.loadData()
    }

    loadData = async () => {
        let id = this.props.id
        let resp = await this.service.GetMovimento(id)
        if (resp.IsValid === true)
            this.setState(resp)
    }

    onSave = async () => {
        let resp = await this.service.SaveMovimento(this.state)
        if (resp.IsValid == true) {
            this.props.do()
            this.props.closeModal()
        }
    }

    render() {
        return (
            <Modal
                title="Modifica categoria"
                width={900}
                visible={this.props.visible}
                onCancel={this.props.closeModal}
                onOk={this.onSave}>
                <Form>
                    <TTFormItem label="Conto Corrente">{this.state.ContoCorrente}</TTFormItem>
                    <TTFormItem label="Descrizione">{this.state.Descrizione}</TTFormItem>
                    <TTFormItem label="Importo">{formatEuro(this.state.Importo)}</TTFormItem>
                    <TTFormItem label="Data">{moment(this.state.Data).format('LLL')}</TTFormItem>
                    <TTFormItem label="Categoria" required={true}>
                        <Cascader autoFocus options={this.state.CategoriaOptions} allowClear={false}
                            showSearch={{ filter }}
                            value={this.state.Categorie} onChange={e => this.setState({ Categorie: e as Array<string> })} />
                    </TTFormItem>
                </Form>
            </Modal>
        )
    }
}